var _rect, _rect2, _text, _text2, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMsStartupsPlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 360,
    height: 88,
    viewBox: "0 0 360 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 359,
    height: 87,
    rx: 14,
    fill: "#121417"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 359,
    height: 87,
    rx: 14,
    stroke: "#22262B"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 20,
    y: 35,
    fill: "#E8EDF5",
    fontFamily: "'Segoe UI', Arial, sans-serif",
    fontSize: 17,
    fontWeight: 600,
    letterSpacing: "0.2px"
  }, "\n    Microsoft for Startups\n  ")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 20,
    y: 60,
    fill: "#78B7C5",
    fontFamily: "'Segoe UI', Arial, sans-serif",
    fontSize: 12,
    fontWeight: 500,
    letterSpacing: "0.3px"
  }, "\n    Placeholder\n  ")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 336,
    cy: 44,
    r: 4.5,
    fill: "#78B7C5",
    fillOpacity: 0.9
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMsStartupsPlaceholder);
export default __webpack_public_path__ + "static/media/ms-startups-placeholder.78f198c5b06b4d8d3c5592cbaa994562.svg";
export { ForwardRef as ReactComponent };